export const privacyAndCookies = {
  en: 'https://company.plarium.com/en/terms/privacy-and-cookie-policy/',
  ru: 'https://company.plarium.com/en/terms/privacy-policy-ru/',
  fr: 'https://company.plarium.com/en/terms/privacy-policy-fr/',
  es: 'https://company.plarium.com/en/terms/privacy-policy-es/',
  de: 'https://company.plarium.com/en/terms/privacy-policy-de/',
  it: 'https://company.plarium.com/en/terms/privacy-policy-it/',
  ko: 'https://company.plarium.com/en/terms/privacy-policy-ko/',
  ja: 'https://company.plarium.com/en/terms/privacy-policy-ja/',
  tr: 'https://company.plarium.com/en/terms/privacy-policy-tr/',
};
